
import '../../App.css';


function Step5({setPage}) {

return (
<div>
    step5
</div>
);
}

export default Step5;
